import React from "react";
import ContactHero from "../../../subscreens/customer/contactHero/ContactHero";
import ContactFormSection from "../../../subscreens/customer/contactFormSection/ContactFormSection";
import QuickAnswersSection from "../../../subscreens/customer/quickAnswersSection/QuickAnswersSection";
import MyLayout from "../../../layouts/customer/MyLayout";

const Contact = () => {
  return (
    <MyLayout>
      <ContactHero />
      <ContactFormSection/>
      <QuickAnswersSection/>
    </MyLayout>
  );
};

export default Contact;
